
const VERSION = process.env.REACT_APP_VERSION || 'snapshot'

export default VERSION
